module.exports = {
  map: { medicationHistory: 'medications' },
  exceptions: ['medicationHistory']
};
